import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

const Search = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg width={width} height={height} style={style} viewBox="0 0 12 12">
      <path d="M5,0c2.761,0 5,2.239 5,5c0,1.246 -0.455,2.385 -1.209,3.26l3.1,3.1c0.146,0.146 0.146,0.384 0,0.53c-0.144,0.143 -0.373,0.147 -0.52,0.011l-0.011,-0.01l-3.1,-3.1c-0.874,0.752 -2.013,1.209 -3.26,1.209c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5Zm0,0.75c-2.347,0 -4.25,1.903 -4.25,4.25c0,2.347 1.903,4.25 4.25,4.25c2.347,0 4.25,-1.903 4.25,-4.25c0,-2.347 -1.903,-4.25 -4.25,-4.25Z" />
    </svg>
  );
};

Search.defaultProps = {
  width: '100%',
  height: '100%',
  style: {},
};
export default Search;
